/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffRequestItem } from './StaffRequestItem';
import {
    StaffRequestItemFromJSON,
    StaffRequestItemFromJSONTyped,
    StaffRequestItemToJSON,
    StaffRequestItemToJSONTyped,
} from './StaffRequestItem';

/**
 * 
 * @export
 * @interface StaffRequestItemResponse
 */
export interface StaffRequestItemResponse {
    /**
     * 
     */
    data: StaffRequestItem;
}

/**
 * Check if a given object implements the StaffRequestItemResponse interface.
 */
export function instanceOfStaffRequestItemResponse(value: object): value is StaffRequestItemResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffRequestItemResponseFromJSON(json: any): StaffRequestItemResponse {
    return StaffRequestItemResponseFromJSONTyped(json, false);
}

export function StaffRequestItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequestItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffRequestItemFromJSON(json['data']),
    };
}

export function StaffRequestItemResponseToJSON(json: any): StaffRequestItemResponse {
    return StaffRequestItemResponseToJSONTyped(json, false);
}

export function StaffRequestItemResponseToJSONTyped(value?: StaffRequestItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffRequestItemToJSON(value['data']),
    };
}

